import Nullstack from 'nullstack';
export default function IconArrowRotaryRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-rotary-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "7",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M8 10v10"
  }), "   ", Nullstack.element("path", {
    d: "M17 11l4 -4l-4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M11 7h10"
  }), " ");
}